import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserActivity } from 'src/app/models/userActivity.model';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';

@Component({
  selector: 'app-user-activity-section',
  templateUrl: './user-activity-section.component.html',
  styleUrls: ['./user-activity-section.component.scss'],
})
export class UserActivitySectionComponent implements OnChanges {
  @Input() kycAccountId: number = 0;
  @Input() showSurveyInstallation: boolean = false;
  @Input() surveyData: any = null;
  @Input() installationData: any = null;

  userActivity?: UserActivity;

  private lastLoadedKycAccountId?: number;

  constructor(
    private accountKycService: AccountKycService,
    private toastr: ToastrService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['kycAccountId'] || !this.kycAccountId) {
      return;
    }

    if (this.lastLoadedKycAccountId === this.kycAccountId) {
      return;
    }

    this.lastLoadedKycAccountId = this.kycAccountId;
    this.getUserActivity();
  }

  private getUserActivity(): void {
    const timezoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.accountKycService.getUserActivity(this.kycAccountId, timezoneValue).subscribe({
      next: (response) => {
        if (response?.status === 200 || response?.status === 'OK') {
          this.userActivity = response.data;
        } else {
          this.userActivity = undefined;
          this.toastr.error(response?.message);
        }
      },
      error: (_) => {
        this.userActivity = undefined;
        this.toastr.error('Error occured');
      },
    });
  }
}
